var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0544434 41.6666L24 0.333252L47.9456 41.6666H0.0544434ZM4.49584 39.0833H43.5042L24 5.49992L4.49584 39.0833ZM24 35.5066C24.4504 35.5066 24.828 35.3542 25.1328 35.0494C25.4376 34.7445 25.59 34.367 25.59 33.9166C25.59 33.4662 25.4376 33.0886 25.1328 32.7838C24.828 32.479 24.4504 32.3265 24 32.3265C23.5496 32.3265 23.172 32.479 22.8672 32.7838C22.5624 33.0886 22.41 33.4662 22.41 33.9166C22.41 34.367 22.5624 34.7445 22.8672 35.0494C23.172 35.3542 23.5496 35.5066 24 35.5066ZM22.7083 29.7432H25.2917V16.8265H22.7083V29.7432Z",
    fill: "#F23434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c69bad9e5b38433cdeebf927654af435.svg";
export { ForwardRef as ReactComponent };